import { useIntl } from 'react-intl';
import { BaseGlobalReportPage } from '../../../common/GlobalReportPage';
import { LowerthirdView } from './LowerthirdView';

export function LowerthirdPage() {
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: 'audit.lowerthird.title',
    defaultMessage: 'Zocalos',
  });

  return (
    <BaseGlobalReportPage title={title}>
      <LowerthirdView />
    </BaseGlobalReportPage>
  );
}
